module.exports = __webpack_public_path__ + "img/community_bg2.c8068d2e.png";